var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"response-history"},[_c('UserDetailsContactInformationRevision'),_vm._v(" "),_c('UserDetailsAdditionalDataResponseRevision',{staticClass:"mt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }